/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConflictError,
  CustomValidationError,
  GigPins,
  GigSerializerForConfirmedProSimplifiedCostsWithExtra,
  GigStats,
  GigsCheckInstantConfirmableRetrieveParams,
  GigsCurrentShiftListParams,
  GigsStatsListParams,
  GigsV2AppliedListParams,
  GigsV2AvailableListParams,
  GigsV2BundleReoffersListParams,
  GigsV2CancelledListParams,
  GigsV2ConversionOffersListParams,
  GigsV2LateShiftsListParams,
  GigsV2ManagedListParams,
  GigsV2PastListParams,
  GigsV2WaitlistedListParams,
  NotFoundError,
  PaginatedAutoMatchList,
  PaginatedGigConversionOfferList,
  PaginatedGigLateShiftList,
  PaginatedGigReadOnlySerializerForAnyProShallowList,
  PaginatedGigReadOnlySerializerForAppliedProList,
  PaginatedGigReadOnlySerializerForPastProList,
  PaginatedProCancelledShiftList,
  PaginatedWaitlistedGigList,
  PatchedWaitlistAlertSeenRequest,
  ProGigRetrieve,
  ScheduledGigsResponse,
  StafferGigViewReadonlySerializerV2,
  WaitlistEntry,
  WaitlistForbidden,
  WorkedAtLocationsResponse
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGigsRetrieveUrl = (id: number,) => {




  return `/api/gigs/${id}/`
}

/**
 * A view allowing Pros to view an individual gig
 */
export const gigsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<ProGigRetrieve> => {

  return customFetch<ProGigRetrieve>(getGigsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/gigs/${id}/`
    ] as const;
    }


export const getGigsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsRetrieve>>> = ({ signal }) => gigsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsRetrieve>>>
export type GigsRetrieveQueryError = void


export function useGigsRetrieve<TData = Awaited<ReturnType<typeof gigsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsRetrieve<TData = Awaited<ReturnType<typeof gigsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsRetrieve<TData = Awaited<ReturnType<typeof gigsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsRetrieve<TData = Awaited<ReturnType<typeof gigsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsAutoMatchesRetrieveUrl = (id: number,) => {




  return `/api/gigs/${id}/auto-matches/`
}

export const gigsAutoMatchesRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedAutoMatchList> => {

  return customFetch<PaginatedAutoMatchList>(getGigsAutoMatchesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsAutoMatchesRetrieveQueryKey = (id: number,) => {
    return [
    `/api/gigs/${id}/auto-matches/`
    ] as const;
    }


export const getGigsAutoMatchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsAutoMatchesRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>> = ({ signal }) => gigsAutoMatchesRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsAutoMatchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>>
export type GigsAutoMatchesRetrieveQueryError = void


export function useGigsAutoMatchesRetrieve<TData = Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsAutoMatchesRetrieve<TData = Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsAutoMatchesRetrieve<TData = Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsAutoMatchesRetrieve<TData = Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsAutoMatchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsAutoMatchesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsWaitlistCreateUrl = (id: number,) => {




  return `/api/gigs/${id}/waitlist/`
}

/**
 * Join the waitlist. 200 when the Pro is already on it.
 */
export const gigsWaitlistCreate = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<WaitlistEntry> => {

  return customFetch<WaitlistEntry>(getGigsWaitlistCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getGigsWaitlistCreateMutationKey = () => ['gigsWaitlistCreate'] as const;

export const getGigsWaitlistCreateMutationOptions = <TError = CustomValidationError | void | WaitlistForbidden | NotFoundError | ConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsWaitlistCreate>>, TError,GigsWaitlistCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsWaitlistCreate>>, TError,GigsWaitlistCreateMutationVariables, TContext> => {

const mutationKey = getGigsWaitlistCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsWaitlistCreate>>, GigsWaitlistCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  gigsWaitlistCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsWaitlistCreateMutationResult = NonNullable<Awaited<ReturnType<typeof gigsWaitlistCreate>>>

    export type GigsWaitlistCreateMutationError = CustomValidationError | void | WaitlistForbidden | NotFoundError | ConflictError
    export type GigsWaitlistCreateMutationVariables = {id: number}

    export const useGigsWaitlistCreate = <TError = CustomValidationError | void | WaitlistForbidden | NotFoundError | ConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsWaitlistCreate>>, TError,GigsWaitlistCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsWaitlistCreate>>,
        TError,
        GigsWaitlistCreateMutationVariables,
        TContext
      > => {
      return useMutation(getGigsWaitlistCreateMutationOptions(options), queryClient);
    }
    export const getGigsWaitlistPartialUpdateUrl = (id: number,) => {




  return `/api/gigs/${id}/waitlist/`
}

/**
 * Record that the Pro saw the last alert's outcome.
 */
export const gigsWaitlistPartialUpdate = async (id: number,
    patchedWaitlistAlertSeenRequest?: PatchedWaitlistAlertSeenRequest, options?: Parameters<typeof customFetch>[1]): Promise<WaitlistEntry> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<WaitlistEntry>(getGigsWaitlistPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedWaitlistAlertSeenRequest)
  }
);}





export const getGigsWaitlistPartialUpdateMutationKey = () => ['gigsWaitlistPartialUpdate'] as const;

export const getGigsWaitlistPartialUpdateMutationOptions = <TError = void | WaitlistForbidden | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsWaitlistPartialUpdate>>, TError,GigsWaitlistPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsWaitlistPartialUpdate>>, TError,GigsWaitlistPartialUpdateMutationVariables, TContext> => {

const mutationKey = getGigsWaitlistPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsWaitlistPartialUpdate>>, GigsWaitlistPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  gigsWaitlistPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsWaitlistPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof gigsWaitlistPartialUpdate>>>
    export type GigsWaitlistPartialUpdateMutationBody = PatchedWaitlistAlertSeenRequest | undefined
    export type GigsWaitlistPartialUpdateMutationError = void | WaitlistForbidden | NotFoundError
    export type GigsWaitlistPartialUpdateMutationVariables = {id: number;data?: PatchedWaitlistAlertSeenRequest}

    export const useGigsWaitlistPartialUpdate = <TError = void | WaitlistForbidden | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsWaitlistPartialUpdate>>, TError,GigsWaitlistPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsWaitlistPartialUpdate>>,
        TError,
        GigsWaitlistPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getGigsWaitlistPartialUpdateMutationOptions(options), queryClient);
    }
    export const getGigsWaitlistDestroyUrl = (id: number,) => {




  return `/api/gigs/${id}/waitlist/`
}

/**
 * Leave the waitlist.
 */
export const gigsWaitlistDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<WaitlistEntry> => {

  return customFetch<WaitlistEntry>(getGigsWaitlistDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getGigsWaitlistDestroyMutationKey = () => ['gigsWaitlistDestroy'] as const;

export const getGigsWaitlistDestroyMutationOptions = <TError = void | WaitlistForbidden | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsWaitlistDestroy>>, TError,GigsWaitlistDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof gigsWaitlistDestroy>>, TError,GigsWaitlistDestroyMutationVariables, TContext> => {

const mutationKey = getGigsWaitlistDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof gigsWaitlistDestroy>>, GigsWaitlistDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  gigsWaitlistDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GigsWaitlistDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof gigsWaitlistDestroy>>>

    export type GigsWaitlistDestroyMutationError = void | WaitlistForbidden | NotFoundError
    export type GigsWaitlistDestroyMutationVariables = {id: number}

    export const useGigsWaitlistDestroy = <TError = void | WaitlistForbidden | NotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof gigsWaitlistDestroy>>, TError,GigsWaitlistDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof gigsWaitlistDestroy>>,
        TError,
        GigsWaitlistDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getGigsWaitlistDestroyMutationOptions(options), queryClient);
    }
    export const getGigsCheckInstantConfirmableRetrieveUrl = (params?: GigsCheckInstantConfirmableRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/check-instant-confirmable/?${stringifiedParams}` : `/api/gigs/check-instant-confirmable/`
}

/**
 * Check which gigs from a given list are eligible for instant confirmation by the requesting pro.
 */
export const gigsCheckInstantConfirmableRetrieve = async (params?: GigsCheckInstantConfirmableRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<number[]> => {

  return customFetch<number[]>(getGigsCheckInstantConfirmableRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsCheckInstantConfirmableRetrieveQueryKey = (params?: GigsCheckInstantConfirmableRetrieveParams,) => {
    return [
    `/api/gigs/check-instant-confirmable/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsCheckInstantConfirmableRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>, TError = void>(params?: GigsCheckInstantConfirmableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsCheckInstantConfirmableRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>> = ({ signal }) => gigsCheckInstantConfirmableRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsCheckInstantConfirmableRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>>
export type GigsCheckInstantConfirmableRetrieveQueryError = void


export function useGigsCheckInstantConfirmableRetrieve<TData = Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>, TError = void>(
 params: undefined |  GigsCheckInstantConfirmableRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsCheckInstantConfirmableRetrieve<TData = Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>, TError = void>(
 params?: GigsCheckInstantConfirmableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsCheckInstantConfirmableRetrieve<TData = Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>, TError = void>(
 params?: GigsCheckInstantConfirmableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsCheckInstantConfirmableRetrieve<TData = Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>, TError = void>(
 params?: GigsCheckInstantConfirmableRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsCheckInstantConfirmableRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsCheckInstantConfirmableRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsCurrentShiftListUrl = (params?: GigsCurrentShiftListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/current-shift/?${stringifiedParams}` : `/api/gigs/current-shift/`
}

/**
 * Returns the current shift if any. Current shift time is defined as two hours before shift start time
 * and two hours after shift end time. Returns a list just in case two gigs are separated by 2-4 hours.
 */
export const gigsCurrentShiftList = async (params?: GigsCurrentShiftListParams, options?: Parameters<typeof customFetch>[1]): Promise<GigSerializerForConfirmedProSimplifiedCostsWithExtra[]> => {

  return customFetch<GigSerializerForConfirmedProSimplifiedCostsWithExtra[]>(getGigsCurrentShiftListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsCurrentShiftListQueryKey = (params?: GigsCurrentShiftListParams,) => {
    return [
    `/api/gigs/current-shift/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsCurrentShiftListQueryOptions = <TData = Awaited<ReturnType<typeof gigsCurrentShiftList>>, TError = void>(params?: GigsCurrentShiftListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsCurrentShiftList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsCurrentShiftListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsCurrentShiftList>>> = ({ signal }) => gigsCurrentShiftList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsCurrentShiftList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsCurrentShiftListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsCurrentShiftList>>>
export type GigsCurrentShiftListQueryError = void


export function useGigsCurrentShiftList<TData = Awaited<ReturnType<typeof gigsCurrentShiftList>>, TError = void>(
 params: undefined |  GigsCurrentShiftListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsCurrentShiftList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsCurrentShiftList>>,
          TError,
          Awaited<ReturnType<typeof gigsCurrentShiftList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsCurrentShiftList<TData = Awaited<ReturnType<typeof gigsCurrentShiftList>>, TError = void>(
 params?: GigsCurrentShiftListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsCurrentShiftList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsCurrentShiftList>>,
          TError,
          Awaited<ReturnType<typeof gigsCurrentShiftList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsCurrentShiftList<TData = Awaited<ReturnType<typeof gigsCurrentShiftList>>, TError = void>(
 params?: GigsCurrentShiftListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsCurrentShiftList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsCurrentShiftList<TData = Awaited<ReturnType<typeof gigsCurrentShiftList>>, TError = void>(
 params?: GigsCurrentShiftListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsCurrentShiftList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsCurrentShiftListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsPinsListUrl = () => {




  return `/api/gigs/pins/`
}

/**
 * Return map pin data for available gigs, aggregated by location address with the highest-earning gig per pin.
 */
export const gigsPinsList = async ( options?: Parameters<typeof customFetch>[1]): Promise<GigPins[]> => {

  return customFetch<GigPins[]>(getGigsPinsListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsPinsListQueryKey = () => {
    return [
    `/api/gigs/pins/`
    ] as const;
    }


export const getGigsPinsListQueryOptions = <TData = Awaited<ReturnType<typeof gigsPinsList>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsPinsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsPinsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsPinsList>>> = ({ signal }) => gigsPinsList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsPinsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsPinsListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsPinsList>>>
export type GigsPinsListQueryError = void


export function useGigsPinsList<TData = Awaited<ReturnType<typeof gigsPinsList>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsPinsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsPinsList>>,
          TError,
          Awaited<ReturnType<typeof gigsPinsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsPinsList<TData = Awaited<ReturnType<typeof gigsPinsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsPinsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsPinsList>>,
          TError,
          Awaited<ReturnType<typeof gigsPinsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsPinsList<TData = Awaited<ReturnType<typeof gigsPinsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsPinsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsPinsList<TData = Awaited<ReturnType<typeof gigsPinsList>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsPinsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsPinsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsStatsListUrl = (params: GigsStatsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/stats/?${stringifiedParams}` : `/api/gigs/stats/`
}

/**
 * This API is designed to be consumed by external client applications like Braze connected content
 */
export const gigsStatsList = async (params: GigsStatsListParams, options?: Parameters<typeof customFetch>[1]): Promise<GigStats[]> => {

  return customFetch<GigStats[]>(getGigsStatsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsStatsListQueryKey = (params?: GigsStatsListParams,) => {
    return [
    `/api/gigs/stats/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsStatsListQueryOptions = <TData = Awaited<ReturnType<typeof gigsStatsList>>, TError = void>(params: GigsStatsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsStatsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsStatsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsStatsList>>> = ({ signal }) => gigsStatsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsStatsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsStatsListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsStatsList>>>
export type GigsStatsListQueryError = void


export function useGigsStatsList<TData = Awaited<ReturnType<typeof gigsStatsList>>, TError = void>(
 params: GigsStatsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsStatsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsStatsList>>,
          TError,
          Awaited<ReturnType<typeof gigsStatsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsStatsList<TData = Awaited<ReturnType<typeof gigsStatsList>>, TError = void>(
 params: GigsStatsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsStatsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsStatsList>>,
          TError,
          Awaited<ReturnType<typeof gigsStatsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsStatsList<TData = Awaited<ReturnType<typeof gigsStatsList>>, TError = void>(
 params: GigsStatsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsStatsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsStatsList<TData = Awaited<ReturnType<typeof gigsStatsList>>, TError = void>(
 params: GigsStatsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsStatsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsStatsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2AppliedListUrl = (params?: GigsV2AppliedListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/v2/applied/?${stringifiedParams}` : `/api/gigs/v2/applied/`
}

/**
 * List gigs the authenticated pro has applied to but has not yet been confirmed for.
 */
export const gigsV2AppliedList = async (params?: GigsV2AppliedListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedGigReadOnlySerializerForAppliedProList> => {

  return customFetch<PaginatedGigReadOnlySerializerForAppliedProList>(getGigsV2AppliedListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2AppliedListInfiniteQueryKey = (params?: GigsV2AppliedListParams,) => {
    return [
    'infinite', `/api/gigs/v2/applied/`, ...(params ? [params] : [])
    ] as const;
    }

export const getGigsV2AppliedListQueryKey = (params?: GigsV2AppliedListParams,) => {
    return [
    `/api/gigs/v2/applied/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsV2AppliedListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof gigsV2AppliedList>>, GigsV2AppliedListParams['page']>, TError = void>(params?: GigsV2AppliedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData, QueryKey, GigsV2AppliedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2AppliedListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2AppliedList>>, QueryKey, GigsV2AppliedListParams['page']> = ({ signal, pageParam }) => gigsV2AppliedList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData, QueryKey, GigsV2AppliedListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2AppliedListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2AppliedList>>>
export type GigsV2AppliedListInfiniteQueryError = void


export function useGigsV2AppliedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2AppliedList>>, GigsV2AppliedListParams['page']>, TError = void>(
 params: undefined |  GigsV2AppliedListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData, QueryKey, GigsV2AppliedListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2AppliedList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2AppliedList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2AppliedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2AppliedList>>, GigsV2AppliedListParams['page']>, TError = void>(
 params?: GigsV2AppliedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData, QueryKey, GigsV2AppliedListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2AppliedList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2AppliedList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2AppliedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2AppliedList>>, GigsV2AppliedListParams['page']>, TError = void>(
 params?: GigsV2AppliedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData, QueryKey, GigsV2AppliedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2AppliedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2AppliedList>>, GigsV2AppliedListParams['page']>, TError = void>(
 params?: GigsV2AppliedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData, QueryKey, GigsV2AppliedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2AppliedListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2AppliedListQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2AppliedList>>, TError = void>(params?: GigsV2AppliedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2AppliedListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2AppliedList>>> = ({ signal }) => gigsV2AppliedList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2AppliedListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2AppliedList>>>
export type GigsV2AppliedListQueryError = void


export function useGigsV2AppliedList<TData = Awaited<ReturnType<typeof gigsV2AppliedList>>, TError = void>(
 params: undefined |  GigsV2AppliedListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2AppliedList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2AppliedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2AppliedList<TData = Awaited<ReturnType<typeof gigsV2AppliedList>>, TError = void>(
 params?: GigsV2AppliedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2AppliedList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2AppliedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2AppliedList<TData = Awaited<ReturnType<typeof gigsV2AppliedList>>, TError = void>(
 params?: GigsV2AppliedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2AppliedList<TData = Awaited<ReturnType<typeof gigsV2AppliedList>>, TError = void>(
 params?: GigsV2AppliedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2AppliedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2AppliedListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2AvailableListUrl = (params?: GigsV2AvailableListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/v2/available/?${stringifiedParams}` : `/api/gigs/v2/available/`
}

/**
 * This API uses cursor pagination, which means that ordering is more restrictive than usual.
 * options for ordering query param are:
 * "?ordering=wage_amount_concat_sort_cursor" which sorts by wage desc, start time asc, posted time asc.
 * "?ordering=start_time_concat_sort_cursor" which sorts by start time asc, posted time asc
 * "?ordering=id" which sorts by most recently posted last
 * "?ordering=distance_concat_sort_cursor" which sorts by distance asc, start_time asc, wage asc, posted time asc
 *
 * Any of these ordering fields can be reversed by prefixing the ordering query param with a "-". For example:
 * "?ordering=-wage_amount_concat_sort_cursor" will sort by wage asc, start time desc, posted time desc
 *
 * In shift waitlist markets, full shifts sort after open ones under every ordering, across pages.
 *
 * Please note that the weekday filter using field named "day" expects values in the following format:
 * '1' for Sunday, '2' for Monday, ..., '7' for Saturday. So for example, "?day=1,7" query will return
 * gigs starting on Saturday or on Sunday.
 */
export const gigsV2AvailableList = async (params?: GigsV2AvailableListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedGigReadOnlySerializerForAnyProShallowList> => {

  return customFetch<PaginatedGigReadOnlySerializerForAnyProShallowList>(getGigsV2AvailableListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2AvailableListQueryKey = (params?: GigsV2AvailableListParams,) => {
    return [
    `/api/gigs/v2/available/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsV2AvailableListQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2AvailableList>>, TError = void>(params?: GigsV2AvailableListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2AvailableList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2AvailableListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2AvailableList>>> = ({ signal }) => gigsV2AvailableList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2AvailableList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2AvailableListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2AvailableList>>>
export type GigsV2AvailableListQueryError = void


export function useGigsV2AvailableList<TData = Awaited<ReturnType<typeof gigsV2AvailableList>>, TError = void>(
 params: undefined |  GigsV2AvailableListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2AvailableList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2AvailableList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2AvailableList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2AvailableList<TData = Awaited<ReturnType<typeof gigsV2AvailableList>>, TError = void>(
 params?: GigsV2AvailableListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2AvailableList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2AvailableList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2AvailableList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2AvailableList<TData = Awaited<ReturnType<typeof gigsV2AvailableList>>, TError = void>(
 params?: GigsV2AvailableListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2AvailableList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2AvailableList<TData = Awaited<ReturnType<typeof gigsV2AvailableList>>, TError = void>(
 params?: GigsV2AvailableListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2AvailableList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2AvailableListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2BundleReoffersListUrl = (params?: GigsV2BundleReoffersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/v2/bundle-reoffers/?${stringifiedParams}` : `/api/gigs/v2/bundle-reoffers/`
}

/**
 * Still-open gigs in bundles the authenticated pro is confirmed in, offered for the pro to pick up
 * via the existing create/confirm flow (like the late feed). Non-exclusive; suspended pros see none.
 */
export const gigsV2BundleReoffersList = async (params?: GigsV2BundleReoffersListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedGigLateShiftList> => {

  return customFetch<PaginatedGigLateShiftList>(getGigsV2BundleReoffersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2BundleReoffersListInfiniteQueryKey = (params?: GigsV2BundleReoffersListParams,) => {
    return [
    'infinite', `/api/gigs/v2/bundle-reoffers/`, ...(params ? [params] : [])
    ] as const;
    }

export const getGigsV2BundleReoffersListQueryKey = (params?: GigsV2BundleReoffersListParams,) => {
    return [
    `/api/gigs/v2/bundle-reoffers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsV2BundleReoffersListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, GigsV2BundleReoffersListParams['page']>, TError = void>(params?: GigsV2BundleReoffersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData, QueryKey, GigsV2BundleReoffersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2BundleReoffersListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, QueryKey, GigsV2BundleReoffersListParams['page']> = ({ signal, pageParam }) => gigsV2BundleReoffersList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData, QueryKey, GigsV2BundleReoffersListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2BundleReoffersListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>>
export type GigsV2BundleReoffersListInfiniteQueryError = void


export function useGigsV2BundleReoffersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, GigsV2BundleReoffersListParams['page']>, TError = void>(
 params: undefined |  GigsV2BundleReoffersListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData, QueryKey, GigsV2BundleReoffersListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2BundleReoffersList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2BundleReoffersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, GigsV2BundleReoffersListParams['page']>, TError = void>(
 params?: GigsV2BundleReoffersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData, QueryKey, GigsV2BundleReoffersListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2BundleReoffersList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2BundleReoffersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, GigsV2BundleReoffersListParams['page']>, TError = void>(
 params?: GigsV2BundleReoffersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData, QueryKey, GigsV2BundleReoffersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2BundleReoffersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, GigsV2BundleReoffersListParams['page']>, TError = void>(
 params?: GigsV2BundleReoffersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData, QueryKey, GigsV2BundleReoffersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2BundleReoffersListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2BundleReoffersListQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError = void>(params?: GigsV2BundleReoffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2BundleReoffersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>> = ({ signal }) => gigsV2BundleReoffersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2BundleReoffersListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>>
export type GigsV2BundleReoffersListQueryError = void


export function useGigsV2BundleReoffersList<TData = Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError = void>(
 params: undefined |  GigsV2BundleReoffersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2BundleReoffersList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2BundleReoffersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2BundleReoffersList<TData = Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError = void>(
 params?: GigsV2BundleReoffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2BundleReoffersList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2BundleReoffersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2BundleReoffersList<TData = Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError = void>(
 params?: GigsV2BundleReoffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2BundleReoffersList<TData = Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError = void>(
 params?: GigsV2BundleReoffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2BundleReoffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2BundleReoffersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2CancelledListUrl = (params?: GigsV2CancelledListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/v2/cancelled/?${stringifiedParams}` : `/api/gigs/v2/cancelled/`
}

/**
 * The pro's cancelled confirmed shifts, acknowledged or not, paid or not, with a sanitized reason.
 * A feed of its own so the /gigs/v2/past/ and /gigs/v2/scheduled/ shapes stay unchanged for current apps.
 */
export const gigsV2CancelledList = async (params?: GigsV2CancelledListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedProCancelledShiftList> => {

  return customFetch<PaginatedProCancelledShiftList>(getGigsV2CancelledListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2CancelledListInfiniteQueryKey = (params?: GigsV2CancelledListParams,) => {
    return [
    'infinite', `/api/gigs/v2/cancelled/`, ...(params ? [params] : [])
    ] as const;
    }

export const getGigsV2CancelledListQueryKey = (params?: GigsV2CancelledListParams,) => {
    return [
    `/api/gigs/v2/cancelled/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsV2CancelledListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof gigsV2CancelledList>>, GigsV2CancelledListParams['page']>, TError = void>(params?: GigsV2CancelledListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData, QueryKey, GigsV2CancelledListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2CancelledListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2CancelledList>>, QueryKey, GigsV2CancelledListParams['page']> = ({ signal, pageParam }) => gigsV2CancelledList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData, QueryKey, GigsV2CancelledListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2CancelledListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2CancelledList>>>
export type GigsV2CancelledListInfiniteQueryError = void


export function useGigsV2CancelledListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2CancelledList>>, GigsV2CancelledListParams['page']>, TError = void>(
 params: undefined |  GigsV2CancelledListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData, QueryKey, GigsV2CancelledListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2CancelledList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2CancelledList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2CancelledListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2CancelledList>>, GigsV2CancelledListParams['page']>, TError = void>(
 params?: GigsV2CancelledListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData, QueryKey, GigsV2CancelledListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2CancelledList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2CancelledList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2CancelledListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2CancelledList>>, GigsV2CancelledListParams['page']>, TError = void>(
 params?: GigsV2CancelledListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData, QueryKey, GigsV2CancelledListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2CancelledListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2CancelledList>>, GigsV2CancelledListParams['page']>, TError = void>(
 params?: GigsV2CancelledListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData, QueryKey, GigsV2CancelledListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2CancelledListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2CancelledListQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2CancelledList>>, TError = void>(params?: GigsV2CancelledListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2CancelledListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2CancelledList>>> = ({ signal }) => gigsV2CancelledList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2CancelledListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2CancelledList>>>
export type GigsV2CancelledListQueryError = void


export function useGigsV2CancelledList<TData = Awaited<ReturnType<typeof gigsV2CancelledList>>, TError = void>(
 params: undefined |  GigsV2CancelledListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2CancelledList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2CancelledList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2CancelledList<TData = Awaited<ReturnType<typeof gigsV2CancelledList>>, TError = void>(
 params?: GigsV2CancelledListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2CancelledList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2CancelledList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2CancelledList<TData = Awaited<ReturnType<typeof gigsV2CancelledList>>, TError = void>(
 params?: GigsV2CancelledListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2CancelledList<TData = Awaited<ReturnType<typeof gigsV2CancelledList>>, TError = void>(
 params?: GigsV2CancelledListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2CancelledList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2CancelledListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2ConversionOffersListUrl = (params?: GigsV2ConversionOffersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/v2/conversion-offers/?${stringifiedParams}` : `/api/gigs/v2/conversion-offers/`
}

/**
 * Pending offers the home banner should prompt the authenticated pro to unblock.
 *
 * Returns gigs where the pro has an application that is selected, not yet confirmed, not cancelled, and
 * has a future start time. CONVERSION_OFFER rows always qualify; for a pro holding no cleared background
 * check, any pending direct offer on a background-check-required shift qualifies too, since an ADMIN /
 * STAFFER / AUTO_DIRECT_OFFER offer blocks on the check exactly as a conversion offer does and the banner
 * is the only surface that prompts for it. Ordered by soonest start_time first.
 */
export const gigsV2ConversionOffersList = async (params?: GigsV2ConversionOffersListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedGigConversionOfferList> => {

  return customFetch<PaginatedGigConversionOfferList>(getGigsV2ConversionOffersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2ConversionOffersListInfiniteQueryKey = (params?: GigsV2ConversionOffersListParams,) => {
    return [
    'infinite', `/api/gigs/v2/conversion-offers/`, ...(params ? [params] : [])
    ] as const;
    }

export const getGigsV2ConversionOffersListQueryKey = (params?: GigsV2ConversionOffersListParams,) => {
    return [
    `/api/gigs/v2/conversion-offers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsV2ConversionOffersListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, GigsV2ConversionOffersListParams['page']>, TError = void>(params?: GigsV2ConversionOffersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData, QueryKey, GigsV2ConversionOffersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2ConversionOffersListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, QueryKey, GigsV2ConversionOffersListParams['page']> = ({ signal, pageParam }) => gigsV2ConversionOffersList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData, QueryKey, GigsV2ConversionOffersListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2ConversionOffersListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>>
export type GigsV2ConversionOffersListInfiniteQueryError = void


export function useGigsV2ConversionOffersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, GigsV2ConversionOffersListParams['page']>, TError = void>(
 params: undefined |  GigsV2ConversionOffersListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData, QueryKey, GigsV2ConversionOffersListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2ConversionOffersList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2ConversionOffersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, GigsV2ConversionOffersListParams['page']>, TError = void>(
 params?: GigsV2ConversionOffersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData, QueryKey, GigsV2ConversionOffersListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2ConversionOffersList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2ConversionOffersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, GigsV2ConversionOffersListParams['page']>, TError = void>(
 params?: GigsV2ConversionOffersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData, QueryKey, GigsV2ConversionOffersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2ConversionOffersListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, GigsV2ConversionOffersListParams['page']>, TError = void>(
 params?: GigsV2ConversionOffersListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData, QueryKey, GigsV2ConversionOffersListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2ConversionOffersListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2ConversionOffersListQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError = void>(params?: GigsV2ConversionOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2ConversionOffersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>> = ({ signal }) => gigsV2ConversionOffersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2ConversionOffersListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>>
export type GigsV2ConversionOffersListQueryError = void


export function useGigsV2ConversionOffersList<TData = Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError = void>(
 params: undefined |  GigsV2ConversionOffersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2ConversionOffersList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2ConversionOffersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2ConversionOffersList<TData = Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError = void>(
 params?: GigsV2ConversionOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2ConversionOffersList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2ConversionOffersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2ConversionOffersList<TData = Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError = void>(
 params?: GigsV2ConversionOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2ConversionOffersList<TData = Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError = void>(
 params?: GigsV2ConversionOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ConversionOffersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2ConversionOffersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2LateShiftsListUrl = (params?: GigsV2LateShiftsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/v2/late-shifts/?${stringifiedParams}` : `/api/gigs/v2/late-shifts/`
}

/**
 * Last-minute unskilled gigs the authenticated pro is eligible to claim (Project Last Call).
 *
 * PR 2 of CORE-5740 — see ticket for the broadcast+claim design. This endpoint backs the
 * new "Last-minute shifts" section the mobile app fuses with /v2/scheduled/ in the Matches
 * tab (PR 5). Response shape is a list of ``{"gig": ...}`` envelopes — NO phantom
 * GigApplication row, the pro claims via the existing GigApplication-create endpoint
 * (first-writer-wins) once they tap Confirm.
 *
 * Eligibility (all must pass — bulk gates live in the manager method, pro-scope gates
 * here so we can short-circuit to .none() without an Exists/JOIN on the gigs query):
 *
 *   * Pro has no active suspension.
 *   * Pro's ``last_app_opened_ts`` OR ``last_gig_confirmed_ts`` is within
 *     ``LATE_SHIFTS_LAST_APP_OPENED_DAYS`` (the OR captures pros who block location
 *     permissions but still confirm gigs).
 *
 * The remaining gates (unskilled gig, POSTED/UNFILLED + open spots + future + within
 * ``LATE_SHIFTS_TAKEOVER_HOURS``, market match, cert/BGC/W2, no overlapping confirmed gig,
 * no existing GigApplication for this gig, org block list) are handled by
 * ``Gig.objects.late_shifts_for_user``. Per-pro pre-flight is delegated to
 * :py:attr:`api.users.models.User.can_see_late_shift_feed`, which is the send-path predicate
 * MINUS the push token: a pro who opted out of notifications may still browse and claim
 * (CORE-7920).
 */
export const gigsV2LateShiftsList = async (params?: GigsV2LateShiftsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedGigLateShiftList> => {

  return customFetch<PaginatedGigLateShiftList>(getGigsV2LateShiftsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2LateShiftsListInfiniteQueryKey = (params?: GigsV2LateShiftsListParams,) => {
    return [
    'infinite', `/api/gigs/v2/late-shifts/`, ...(params ? [params] : [])
    ] as const;
    }

export const getGigsV2LateShiftsListQueryKey = (params?: GigsV2LateShiftsListParams,) => {
    return [
    `/api/gigs/v2/late-shifts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsV2LateShiftsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, GigsV2LateShiftsListParams['page']>, TError = void>(params?: GigsV2LateShiftsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData, QueryKey, GigsV2LateShiftsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2LateShiftsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, QueryKey, GigsV2LateShiftsListParams['page']> = ({ signal, pageParam }) => gigsV2LateShiftsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData, QueryKey, GigsV2LateShiftsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2LateShiftsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2LateShiftsList>>>
export type GigsV2LateShiftsListInfiniteQueryError = void


export function useGigsV2LateShiftsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, GigsV2LateShiftsListParams['page']>, TError = void>(
 params: undefined |  GigsV2LateShiftsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData, QueryKey, GigsV2LateShiftsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2LateShiftsList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2LateShiftsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2LateShiftsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, GigsV2LateShiftsListParams['page']>, TError = void>(
 params?: GigsV2LateShiftsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData, QueryKey, GigsV2LateShiftsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2LateShiftsList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2LateShiftsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2LateShiftsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, GigsV2LateShiftsListParams['page']>, TError = void>(
 params?: GigsV2LateShiftsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData, QueryKey, GigsV2LateShiftsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2LateShiftsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, GigsV2LateShiftsListParams['page']>, TError = void>(
 params?: GigsV2LateShiftsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData, QueryKey, GigsV2LateShiftsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2LateShiftsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2LateShiftsListQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError = void>(params?: GigsV2LateShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2LateShiftsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2LateShiftsList>>> = ({ signal }) => gigsV2LateShiftsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2LateShiftsListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2LateShiftsList>>>
export type GigsV2LateShiftsListQueryError = void


export function useGigsV2LateShiftsList<TData = Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError = void>(
 params: undefined |  GigsV2LateShiftsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2LateShiftsList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2LateShiftsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2LateShiftsList<TData = Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError = void>(
 params?: GigsV2LateShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2LateShiftsList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2LateShiftsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2LateShiftsList<TData = Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError = void>(
 params?: GigsV2LateShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2LateShiftsList<TData = Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError = void>(
 params?: GigsV2LateShiftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2LateShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2LateShiftsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2ManagedListUrl = (params?: GigsV2ManagedListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/v2/managed/?${stringifiedParams}` : `/api/gigs/v2/managed/`
}

/**
 * Allows a Pro with a management role to list manageable gigs.
 * All filters are optional and handled via a FilterSet.
 */
export const gigsV2ManagedList = async (params?: GigsV2ManagedListParams, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigViewReadonlySerializerV2[]> => {

  return customFetch<StafferGigViewReadonlySerializerV2[]>(getGigsV2ManagedListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2ManagedListQueryKey = (params?: GigsV2ManagedListParams,) => {
    return [
    `/api/gigs/v2/managed/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsV2ManagedListQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2ManagedList>>, TError = void>(params?: GigsV2ManagedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2ManagedListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2ManagedList>>> = ({ signal }) => gigsV2ManagedList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2ManagedListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2ManagedList>>>
export type GigsV2ManagedListQueryError = void


export function useGigsV2ManagedList<TData = Awaited<ReturnType<typeof gigsV2ManagedList>>, TError = void>(
 params: undefined |  GigsV2ManagedListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2ManagedList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2ManagedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2ManagedList<TData = Awaited<ReturnType<typeof gigsV2ManagedList>>, TError = void>(
 params?: GigsV2ManagedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2ManagedList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2ManagedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2ManagedList<TData = Awaited<ReturnType<typeof gigsV2ManagedList>>, TError = void>(
 params?: GigsV2ManagedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2ManagedList<TData = Awaited<ReturnType<typeof gigsV2ManagedList>>, TError = void>(
 params?: GigsV2ManagedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2ManagedListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2ManagedRetrieveUrl = (id: number,) => {




  return `/api/gigs/v2/managed/${id}/`
}

/**
 * Allows a Pro with a management role to list manageable gigs.
 * All filters are optional and handled via a FilterSet.
 */
export const gigsV2ManagedRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<StafferGigViewReadonlySerializerV2> => {

  return customFetch<StafferGigViewReadonlySerializerV2>(getGigsV2ManagedRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2ManagedRetrieveQueryKey = (id: number,) => {
    return [
    `/api/gigs/v2/managed/${id}/`
    ] as const;
    }


export const getGigsV2ManagedRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2ManagedRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>> = ({ signal }) => gigsV2ManagedRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2ManagedRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>>
export type GigsV2ManagedRetrieveQueryError = void


export function useGigsV2ManagedRetrieve<TData = Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2ManagedRetrieve<TData = Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2ManagedRetrieve<TData = Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2ManagedRetrieve<TData = Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ManagedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2ManagedRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2PastListUrl = (params?: GigsV2PastListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/v2/past/?${stringifiedParams}` : `/api/gigs/v2/past/`
}

/**
 * List completed and past gigs the authenticated pro was confirmed for.
 */
export const gigsV2PastList = async (params?: GigsV2PastListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedGigReadOnlySerializerForPastProList> => {

  return customFetch<PaginatedGigReadOnlySerializerForPastProList>(getGigsV2PastListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2PastListInfiniteQueryKey = (params?: GigsV2PastListParams,) => {
    return [
    'infinite', `/api/gigs/v2/past/`, ...(params ? [params] : [])
    ] as const;
    }

export const getGigsV2PastListQueryKey = (params?: GigsV2PastListParams,) => {
    return [
    `/api/gigs/v2/past/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsV2PastListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof gigsV2PastList>>, GigsV2PastListParams['page']>, TError = void>(params?: GigsV2PastListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData, QueryKey, GigsV2PastListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2PastListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2PastList>>, QueryKey, GigsV2PastListParams['page']> = ({ signal, pageParam }) => gigsV2PastList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData, QueryKey, GigsV2PastListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2PastListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2PastList>>>
export type GigsV2PastListInfiniteQueryError = void


export function useGigsV2PastListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2PastList>>, GigsV2PastListParams['page']>, TError = void>(
 params: undefined |  GigsV2PastListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData, QueryKey, GigsV2PastListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2PastList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2PastList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2PastListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2PastList>>, GigsV2PastListParams['page']>, TError = void>(
 params?: GigsV2PastListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData, QueryKey, GigsV2PastListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2PastList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2PastList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2PastListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2PastList>>, GigsV2PastListParams['page']>, TError = void>(
 params?: GigsV2PastListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData, QueryKey, GigsV2PastListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2PastListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2PastList>>, GigsV2PastListParams['page']>, TError = void>(
 params?: GigsV2PastListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData, QueryKey, GigsV2PastListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2PastListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2PastListQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2PastList>>, TError = void>(params?: GigsV2PastListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2PastListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2PastList>>> = ({ signal }) => gigsV2PastList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2PastListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2PastList>>>
export type GigsV2PastListQueryError = void


export function useGigsV2PastList<TData = Awaited<ReturnType<typeof gigsV2PastList>>, TError = void>(
 params: undefined |  GigsV2PastListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2PastList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2PastList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2PastList<TData = Awaited<ReturnType<typeof gigsV2PastList>>, TError = void>(
 params?: GigsV2PastListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2PastList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2PastList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2PastList<TData = Awaited<ReturnType<typeof gigsV2PastList>>, TError = void>(
 params?: GigsV2PastListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2PastList<TData = Awaited<ReturnType<typeof gigsV2PastList>>, TError = void>(
 params?: GigsV2PastListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2PastListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2PastWorkedAtLocationsRetrieveUrl = () => {




  return `/api/gigs/v2/past/worked-at-locations/`
}

/**
 * Return locations where the pro has worked, for filter dropdown.
 */
export const gigsV2PastWorkedAtLocationsRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<WorkedAtLocationsResponse> => {

  return customFetch<WorkedAtLocationsResponse>(getGigsV2PastWorkedAtLocationsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2PastWorkedAtLocationsRetrieveQueryKey = () => {
    return [
    `/api/gigs/v2/past/worked-at-locations/`
    ] as const;
    }


export const getGigsV2PastWorkedAtLocationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2PastWorkedAtLocationsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>> = ({ signal }) => gigsV2PastWorkedAtLocationsRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2PastWorkedAtLocationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>>
export type GigsV2PastWorkedAtLocationsRetrieveQueryError = void


export function useGigsV2PastWorkedAtLocationsRetrieve<TData = Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2PastWorkedAtLocationsRetrieve<TData = Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2PastWorkedAtLocationsRetrieve<TData = Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2PastWorkedAtLocationsRetrieve<TData = Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2PastWorkedAtLocationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2PastWorkedAtLocationsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2ScheduledRetrieveUrl = () => {




  return `/api/gigs/v2/scheduled/`
}

/**
 * This adds the badge_count to the list response. Badge_count represents the number of gigs in the scheduled
 * tab that have a red dot and require some form of confirmation from the pro, either because the pro was selected
 * for a gig but has not confirmed yet, or because the pro's application was cancelled for some reason, and they
 * need to acknowledge. This badge_count is displayed at the bottom of the mobile app on the schedule icon in a
 * red circle.
 * This method also removes from the list other gigs that overlap with confirmed gigs.
 */
export const gigsV2ScheduledRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<ScheduledGigsResponse> => {

  return customFetch<ScheduledGigsResponse>(getGigsV2ScheduledRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2ScheduledRetrieveQueryKey = () => {
    return [
    `/api/gigs/v2/scheduled/`
    ] as const;
    }


export const getGigsV2ScheduledRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2ScheduledRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>> = ({ signal }) => gigsV2ScheduledRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2ScheduledRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>>
export type GigsV2ScheduledRetrieveQueryError = void


export function useGigsV2ScheduledRetrieve<TData = Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2ScheduledRetrieve<TData = Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>,
          TError,
          Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2ScheduledRetrieve<TData = Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2ScheduledRetrieve<TData = Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2ScheduledRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2ScheduledRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2WaitlistedListUrl = (params?: GigsV2WaitlistedListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/gigs/v2/waitlisted/?${stringifiedParams}` : `/api/gigs/v2/waitlisted/`
}

/**
 * Shifts whose waitlist the Pro is on (CORE-8715): ACTIVE entries with an open alert first, then by start,
 * followed by entries that ended in the last 24 hours.
 */
export const gigsV2WaitlistedList = async (params?: GigsV2WaitlistedListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedWaitlistedGigList> => {

  return customFetch<PaginatedWaitlistedGigList>(getGigsV2WaitlistedListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGigsV2WaitlistedListInfiniteQueryKey = (params?: GigsV2WaitlistedListParams,) => {
    return [
    'infinite', `/api/gigs/v2/waitlisted/`, ...(params ? [params] : [])
    ] as const;
    }

export const getGigsV2WaitlistedListQueryKey = (params?: GigsV2WaitlistedListParams,) => {
    return [
    `/api/gigs/v2/waitlisted/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGigsV2WaitlistedListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, GigsV2WaitlistedListParams['page']>, TError = void>(params?: GigsV2WaitlistedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData, QueryKey, GigsV2WaitlistedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2WaitlistedListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, QueryKey, GigsV2WaitlistedListParams['page']> = ({ signal, pageParam }) => gigsV2WaitlistedList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData, QueryKey, GigsV2WaitlistedListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2WaitlistedListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2WaitlistedList>>>
export type GigsV2WaitlistedListInfiniteQueryError = void


export function useGigsV2WaitlistedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, GigsV2WaitlistedListParams['page']>, TError = void>(
 params: undefined |  GigsV2WaitlistedListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData, QueryKey, GigsV2WaitlistedListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2WaitlistedList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2WaitlistedList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2WaitlistedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, GigsV2WaitlistedListParams['page']>, TError = void>(
 params?: GigsV2WaitlistedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData, QueryKey, GigsV2WaitlistedListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2WaitlistedList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2WaitlistedList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2WaitlistedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, GigsV2WaitlistedListParams['page']>, TError = void>(
 params?: GigsV2WaitlistedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData, QueryKey, GigsV2WaitlistedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2WaitlistedListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, GigsV2WaitlistedListParams['page']>, TError = void>(
 params?: GigsV2WaitlistedListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData, QueryKey, GigsV2WaitlistedListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2WaitlistedListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGigsV2WaitlistedListQueryOptions = <TData = Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError = void>(params?: GigsV2WaitlistedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGigsV2WaitlistedListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gigsV2WaitlistedList>>> = ({ signal }) => gigsV2WaitlistedList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GigsV2WaitlistedListQueryResult = NonNullable<Awaited<ReturnType<typeof gigsV2WaitlistedList>>>
export type GigsV2WaitlistedListQueryError = void


export function useGigsV2WaitlistedList<TData = Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError = void>(
 params: undefined |  GigsV2WaitlistedListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2WaitlistedList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2WaitlistedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2WaitlistedList<TData = Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError = void>(
 params?: GigsV2WaitlistedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gigsV2WaitlistedList>>,
          TError,
          Awaited<ReturnType<typeof gigsV2WaitlistedList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGigsV2WaitlistedList<TData = Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError = void>(
 params?: GigsV2WaitlistedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGigsV2WaitlistedList<TData = Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError = void>(
 params?: GigsV2WaitlistedListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gigsV2WaitlistedList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGigsV2WaitlistedListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






